<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Cleaver</h3>
    </div>
</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>
                <div class="col-12">
                    <button class="btn waves-effect btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>
                    <button type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>

                </div>

                
                        
                            <!-- sample modal content -->
                            <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel">Cleaver</h4>
   
                                        </div>
                                        <div class="modal-body">
                                            <p>{{index + 1}}/{{questions.length}} Seleccione la palabra que más lo identifique primero y la que menos lo identifique luego</p>

                                            
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <button type="button" class="btn btn-block btn-lg btn-info" (click)="select('0')" >{{selectedQuestion.opcA.text}}
                                                            <label class="mytooltip button-tooltip pointer"><b class="text-white"><small><b>?</b></small></b>
                                                                <span class="tooltip-content4 text-center">
                                                                    {{selectedQuestion.opcA.text | cleaverGlossary}} 
                                                                </span>
                                                            </label>
                                                        </button>

                                                    </div>
                                                    <div class="col-md-2">
                                                        <span *ngIf="orderAnswers[0]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[0]==2" class="badge badge-warning ml-auto">Menos</span>
                                                        <br>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <button type="button" class="btn btn-block btn-lg btn-info" (click)="select('1')" >{{selectedQuestion.opcB.text}}
                                                            <label class="mytooltip button-tooltip pointer"><b class="text-white"><small><b>?</b></small></b>
                                                                <span class="tooltip-content4 text-center">
                                                                    {{selectedQuestion.opcB.text | cleaverGlossary}} 
                                                                </span>
                                                            </label>
                                                        </button>

                                                    </div>
                                                    <div class="col-md-2">
                                                        <span *ngIf="orderAnswers[1]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[1]==2" class="badge badge-warning ml-auto">Menos</span>
                                                        <br>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <button type="button" class="btn btn-block btn-lg btn-info" (click)="select('2')" >{{selectedQuestion.opcC.text}}
                                                            <label class="mytooltip button-tooltip pointer"><b class="text-white"><small><b>?</b></small></b>
                                                                <span class="tooltip-content4 text-center">
                                                                    {{selectedQuestion.opcC.text | cleaverGlossary}} 
                                                                </span>
                                                            </label>
                                                        </button>

                                                    </div>
                                                    <div class="col-md-2">

                                                        <span *ngIf="orderAnswers[2]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[2]==2" class="badge badge-warning ml-auto">Menos</span>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <button type="button" class="btn btn-block btn-lg btn-info" (click)="select('3')" >{{selectedQuestion.opcD.text}}
                                                            <label class="mytooltip button-tooltip pointer"><b class="text-white"><small><b>?</b></small></b>
                                                                <span class="tooltip-content4 text-center">
                                                                    {{selectedQuestion.opcD.text | cleaverGlossary}} 
                                                                </span>
                                                            </label>
                                                        </button>

                                                    </div>
                                                    <div class="col-md-2">

                                                        <span *ngIf="orderAnswers[3]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[3]==2" class="badge badge-warning ml-auto">Menos</span>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <button type="button" class="btn btn-danger waves-effect m-r-20" (click)="clear()">Borrar respuestas</button>
                                                    
                                                </div>
                                                <div class="col-sm-6">
                                                    
                                                    <button type="button" class="btn btn-info waves-effect" (click)="nextQuestion()" >Siguiente</button>
                                                </div>
                                                

                                            </div>
                                        </div>

                                    </div>
                                    <!-- /.modal-content -->
                                </div>
                                <!-- /.modal-dialog -->
                            </div>
                            <!-- /.modal -->
                      
               
            </div>
        </div>
    </div>
</div>